const INITIAL_STATE = {
    state: {
        doxyVersion: {
            version: 1,
            platform: 'web',
        },
        username: '',
        hasCamera: true,
        cameraStatus: 'success',
        quality: '',
        status: '',
        privateData: null,
        onlyChat: false,
    },
    uuid: '',
};
export { INITIAL_STATE };
